/**
 * @generated SignedSource<<7cf2646009b5cbeacadbd2981ae4c724>>
 * @relayHash de1a3ad7103e5f1f34b2ddcb6cce2420
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ee1fad18784cb4de28a044ddec3469e8c5d86a523313ff94fb6acae9de9554ed

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type overview_agentIdentityQuery$variables = {
  helpCenterAri: string;
};
export type overview_agentIdentityQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianCsmAgentOverview" | "agentIdentity_AtlassianCsmAgentIdentity_agentRef">;
    } | null | undefined;
  } | null | undefined;
};
export type overview_agentIdentityQuery = {
  response: overview_agentIdentityQuery$data;
  variables: overview_agentIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "agentCard_AtlassianCsmAgentOverview"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "agentIdentity_AtlassianCsmAgentIdentity_agentRef"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "companyName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "companyDescription"
                      },
                      {
                        "concreteType": "CsmAiAgentTone",
                        "kind": "LinkedField",
                        "name": "tone",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "greetingMessage"
                      },
                      {
                        "concreteType": "CsmAiAgentConversationStarter",
                        "kind": "LinkedField",
                        "name": "conversationStarters",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "message"
                          },
                          (v3/*: any*/)
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ee1fad18784cb4de28a044ddec3469e8c5d86a523313ff94fb6acae9de9554ed",
    "metadata": {},
    "name": "overview_agentIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "afa6c6513ac79e69b5a4254589193e25";

export default node;
